// Translates MUI v5 `sx` prop values into a plain CSS-in-JS style object usable
// by MUI v4 components. Handles the common subset used in this codebase:
// spacing tokens (m/mt/mb/ml/mr/mx/my/p/pt/pb/pl/pr/px/py/gap), bgcolor, and
// any other CSS property names that pass through unchanged.
//
// Not handled (sx values that fall back to literal CSS): responsive breakpoint
// objects, theme.palette token lookups like 'primary.main', the `&:hover` etc.
// pseudo-class keys. If you hit one of those, convert the call site to
// makeStyles or inline style and remove the sx prop.

const SPACING = 8;

const SPACING_KEYS = new Set([
  'm', 'mt', 'mb', 'ml', 'mr', 'mx', 'my',
  'p', 'pt', 'pb', 'pl', 'pr', 'px', 'py',
  'gap', 'rowGap', 'columnGap',
]);

const ALIAS = {
  m: ['margin'],
  mt: ['marginTop'],
  mb: ['marginBottom'],
  ml: ['marginLeft'],
  mr: ['marginRight'],
  mx: ['marginLeft', 'marginRight'],
  my: ['marginTop', 'marginBottom'],
  p: ['padding'],
  pt: ['paddingTop'],
  pb: ['paddingBottom'],
  pl: ['paddingLeft'],
  pr: ['paddingRight'],
  px: ['paddingLeft', 'paddingRight'],
  py: ['paddingTop', 'paddingBottom'],
  bgcolor: ['backgroundColor'],
};

export const sxToStyle = (sx) => {
  if (!sx || typeof sx !== 'object') return {};
  // If caller passed an array of sx objects (v5 supports this), merge them.
  if (Array.isArray(sx)) {
    return sx.reduce((acc, item) => ({ ...acc, ...sxToStyle(item) }), {});
  }
  const out = {};
  for (const [key, raw] of Object.entries(sx)) {
    const targets = ALIAS[key] || [key];
    let value = raw;
    if (SPACING_KEYS.has(key) && typeof raw === 'number') {
      value = raw * SPACING;
    }
    for (const t of targets) {
      out[t] = value;
    }
  }
  return out;
};

export default sxToStyle;
